import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { CloseIcon, ChevronLeftIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useIsLandscape } from "@/hooks";
import { Tabs } from "@/components/UI/Tabs";
import { ScrollableElements } from "@/components/UI/ScrollableElements";
import { useGalleryContext } from "@/gallery/contexts";
import { ContactingEntryPoint } from "@/components/contacting/EntryPoints";
const IconMap = {
    back: ChevronLeftIcon,
    close: CloseIcon,
};
export const ModalTopBar = ({ closeAction, headline, buttonLabel, testId, additionalCTAs, closeIcon = "back", showControls = true, variant = "light", showTabs = true, showContacting = false, tracking, }) => {
    const isLandscape = useIsLandscape();
    const isLight = variant === "light";
    const { tabs, onTabChange, activeTab } = useGalleryContext();
    const landscapeStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        overflow: "hidden",
        opacity: showControls ? "opacity.full" : "opacity.none",
        backgroundColor: "color.surface.constant.blackTransparent.default",
        transitionDuration: "motionDuration.150",
        transitionTimingFunction: "motionEasing.linear",
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { position: "sticky", top: 0, height: "sizing.64", paddingVertical: "spacing.16", paddingHorizontal: "spacing.16", display: "flex", alignItems: "center", justifyContent: "space-between", zIndex: "zIndex.1", width: "100%", backgroundColor: isLight
                    ? "color.content.constant.white"
                    : "color.border.constant.black", opacity: showControls ? "opacity.full" : "opacity.none", borderBottomStyle: "solid", borderBottomWidth: "borderWidth.1", borderBottomColor: "color.border.subdued.default", testId: testId, ...(isLandscape && !isLight && landscapeStyle), children: [_jsx(Button, { onPress: closeAction, icon: IconMap[closeIcon], variant: isLight ? "tertiary" : "tertiary-inverted", iconOnly: !buttonLabel ||
                            (closeIcon === "back"
                                ? {
                                    "breakpoint.base": true,
                                    "breakpoint.lg": false,
                                }
                                : true), size: "40", testId: testId ? `${testId}.CloseAction` : undefined, children: buttonLabel }), headline && (_jsx(Box, { as: "span", typography: "typography.body.16.bold", color: isLight
                            ? "color.content.constant.black"
                            : "color.content.constant.white", display: {
                            "breakpoint.base": "none",
                            "breakpoint.md": "block",
                        }, children: headline })), showTabs && tabs && (_jsx(Box, { marginLeft: "spacing.32", marginRight: "auto", display: {
                            "breakpoint.base": "none",
                            "breakpoint.md": "flex",
                        }, children: _jsx(Tabs, { tabs: tabs, onTabChange: onTabChange, value: activeTab }) })), showContacting && (_jsx(Box, { display: {
                            "breakpoint.base": "none",
                            "breakpoint.lg": "flex",
                        }, marginRight: "spacing.12", marginLeft: "auto", children: _jsx(ContactingEntryPoint, { shouldDisplay: showContacting, display: "inline", tracking: tracking, variant: variant }) })), additionalCTAs && (_jsx(Box, { typography: "typography.body.16.bold", color: isLight
                            ? "color.content.constant.black"
                            : "color.content.constant.white", children: additionalCTAs }))] }), showTabs && tabs && (_jsx(Box, { display: {
                    "breakpoint.base": "flex",
                    "breakpoint.md": "none",
                }, paddingHorizontal: "spacing.16", paddingVertical: "spacing.12", borderBottomStyle: "solid", borderBottomWidth: "borderWidth.1", borderBottomColor: "color.border.subdued.default", height: "sizing.64", opacity: showControls ? "opacity.full" : "opacity.none", children: _jsx(ScrollableElements, { children: _jsx(Tabs, { tabs: tabs, onTabChange: onTabChange, value: activeTab }) }) }))] }));
};
